import * as statistical from './statistical'
import * as userManager from './userManager'
import * as auctionManager from './auctionManager'
import * as auth from './auth'
import * as user from './user'
import * as comments from './comments'
import * as support from './support'
import * as carManager from './carManager'
import * as salesRevenueManager from './salesRevenueManager'
import * as managersManager from './managersManager'
import * as blogManager from './blogManager'
import * as auctionBannerManager from './auctionBanner'
import * as dealerManager from './dealers'
import * as paymentsManager from './payments'
import * as taxCreditManager from './taxCredit'
import * as marketplaceManager from './marketplace'
import * as vdpManager from './vdpManager'

export const services = {
  statistical,
  userManager,
  auctionManager,
  auth,
  user,
  comments,
  support,
  carManager,
  salesRevenueManager,
  managersManager,
  blogManager,
  auctionBannerManager,
  dealerManager,
  paymentsManager,
  taxCreditManager,
  marketplaceManager,
  vdpManager
}

/**
 *
 * @param {Socket} socket
*/
export function bindWsEventsToServices (socket) {
  for (const service of Object.values(services)) {
    service.bindWsEvents && service.bindWsEvents(socket)
  }
}
